import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormFieldModule } from '@shared/components/games/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { ParametersModule } from '@games/core/parameters/parameters.module';

@Component({
  selector: 'ms-global-parameters',
  imports: [CommonModule, ReactiveFormsModule, FormFieldModule, TranslateModule, ParametersModule],
  templateUrl: './global-parameters.component.html',
  styleUrls: ['./global-parameters.component.scss'],
})
export class GlobalParametersComponent {
  @Input() taskEndSongHidden: boolean = false;
  @Input() color:
    | 'yellow'
    | 'green'
    | 'blue'
    | 'red'
    | 'accent'
    | 'primary'
    | 'purple'
    | 'water'
    | 'tree'
    | 'fire'
    | null = null;
}
